import {put, takeLatest, call} from 'redux-saga/effects';
import {toast} from 'react-toastify';
import {get} from 'lodash';
import {
  fetchOwnerDashboardFiltersRequest,
  fetchOwnerDashboardFiltersSuccess,
  fetchOwnerDashboardFiltersError,
  fetchOwnerDashboardGlobalViewRequest,
  fetchOwnerDashboardGlobalViewSuccess,
  fetchOwnerDashboardGlobalViewError,
  fetchOwnerDashboardCorporatesRequest,
  fetchOwnerDashboardCorporatesSuccess,
  fetchOwnerDashboardCorporatesError,
  fetchOwnerDashboardCorporateFacilitiesRequest,
  fetchOwnerDashboardCorporateFacilitiesSuccess,
  fetchOwnerDashboardCorporateFacilitiesError,
  fetchOwnerDashboardCorporateFacilityDetailsRequest,
  fetchOwnerDashboardCorporateFacilityDetailsSuccess,
  fetchOwnerDashboardCorporateFacilityDetailsError,
  selectCorporate,
} from './index';
import {
  fetchOwnerDashboardFilters,
  fetchOwnerDashboardGlobalView,
  fetchOwnerDashboardCorporates,
  fetchOwnerDashboardCorporateFacilities,
  fetchOwnerDashboardCorporateFacilityDetails,
} from './api';

export const sagaActions = {
  FETCH_OWNER_DASHBOARD_FILTERS: 'FETCH_OWNER_DASHBOARD_FILTERS',
  FETCH_OWNER_DASHBOARD_GLOBAL_VIEW: 'FETCH_OWNER_DASHBOARD_GLOBAL_VIEW',
  FETCH_OWNER_DASHBOARD_CORPORATES: 'FETCH_OWNER_DASHBOARD_CORPORATES',
  SELECT_CORPORATE: 'SELECT_CORPORATE',
  FETCH_OWNER_DASHBOARD_CORPORATE_FACILITIES:
    'FETCH_OWNER_DASHBOARD_CORPORATE_FACILITIES',
  FETCH_OWNER_DASHBOARD_CORPORATE_FACILITY_DETAILS:
    'FETCH_OWNER_DASHBOARD_CORPORATE_FACILITY_DETAILS',
};

function* fetchOwnerDashboardFiltersSaga({payload}) {
  const {values} = payload;
  try {
    yield put(fetchOwnerDashboardFiltersRequest());
    const result = yield call(fetchOwnerDashboardFilters, values);
    if (!result.error) {
      yield put(fetchOwnerDashboardFiltersSuccess(result));
    } else if (result.error) {
      yield put(
        fetchOwnerDashboardFiltersSuccess({
          data: null,
        })
      );
    }
  } catch (e) {
    const message = get(e, 'response.message', '');
    if (message) {
      toast.error(message);
      yield put(fetchOwnerDashboardFiltersError(message));
    } else {
      toast.error(e.error);
      yield put(fetchOwnerDashboardFiltersError(e.error));
    }
  }
}

function* fetchOwnerDashboardGlobalViewSaga({payload}) {
  const {values} = payload;
  try {
    yield put(fetchOwnerDashboardGlobalViewRequest());
    const result = yield call(fetchOwnerDashboardGlobalView, values);
    if (!result.error) {
      yield put(fetchOwnerDashboardGlobalViewSuccess(result));
    } else if (result.error) {
      yield put(
        fetchOwnerDashboardGlobalViewSuccess({
          data: {},
        })
      );
    }
  } catch (e) {
    const message = get(e, 'response.message', '');
    if (message) {
      toast.error(message);
      yield put(fetchOwnerDashboardGlobalViewError(message));
    } else {
      toast.error(e.error);
      yield put(fetchOwnerDashboardGlobalViewError(e.error));
    }
  }
}

function* fetchOwnerDashboardCorporatesSaga({payload}) {
  const {values} = payload;
  try {
    yield put(fetchOwnerDashboardCorporatesRequest());
    const result = yield call(fetchOwnerDashboardCorporates, values);
    if (!result.error) {
      yield put(fetchOwnerDashboardCorporatesSuccess(result.data));
    } else if (result.error) {
      yield put(
        fetchOwnerDashboardCorporatesSuccess({
          data: [],
        })
      );
    }
  } catch (e) {
    const message = get(e, 'response.message', '');
    if (message) {
      toast.error(message);
      yield put(fetchOwnerDashboardCorporatesError(message));
    } else {
      toast.error(e.error);
      yield put(fetchOwnerDashboardCorporatesError(e.error));
    }
  }
}

function* selectCorporateSaga({payload}) {
  const {corporate} = payload;
  try {
    yield put(selectCorporate(corporate));
  } catch (e) {
    yield put(selectCorporate(null));
  }
}

function* fetchOwnerDashboardCorporateFacilitiesSaga({payload}) {
  const {values, corporateId} = payload;
  try {
    yield put(fetchOwnerDashboardCorporateFacilitiesRequest());
    const result = yield call(
      fetchOwnerDashboardCorporateFacilities,
      corporateId,
      values
    );
    if (!result.error) {
      yield put(fetchOwnerDashboardCorporateFacilitiesSuccess(result.data));
    } else if (result.error) {
      yield put(
        fetchOwnerDashboardCorporateFacilitiesSuccess({
          data: [],
        })
      );
    }
  } catch (e) {
    const message = get(e, 'response.message', '');
    if (message) {
      toast.error(message);
      yield put(fetchOwnerDashboardCorporateFacilitiesError(message));
    } else {
      toast.error(e.error);
      yield put(fetchOwnerDashboardCorporateFacilitiesError(e.error));
    }
  }
}

function* fetchOwnerDashboardCorporateFacilityDetailsSaga({payload}) {
  const {values, corporateId, facilityId} = payload;
  try {
    yield put(fetchOwnerDashboardCorporateFacilityDetailsRequest());
    const result = yield call(
      fetchOwnerDashboardCorporateFacilityDetails,
      corporateId,
      facilityId,
      values
    );
    if (!result.error) {
      yield put(fetchOwnerDashboardCorporateFacilityDetailsSuccess(result));
    } else if (result.error) {
      yield put(
        fetchOwnerDashboardCorporateFacilityDetailsSuccess({
          data: [],
        })
      );
    }
  } catch (e) {
    const message = get(e, 'response.message', '');
    if (message) {
      toast.error(message);
      yield put(fetchOwnerDashboardCorporateFacilityDetailsError(message));
    } else {
      toast.error(e.error);
      yield put(fetchOwnerDashboardCorporateFacilityDetailsError(e.error));
    }
  }
}

function* rootSagas() {
  yield takeLatest(
    sagaActions.FETCH_OWNER_DASHBOARD_FILTERS,
    fetchOwnerDashboardFiltersSaga
  );
  yield takeLatest(
    sagaActions.FETCH_OWNER_DASHBOARD_GLOBAL_VIEW,
    fetchOwnerDashboardGlobalViewSaga
  );

  yield takeLatest(
    sagaActions.FETCH_OWNER_DASHBOARD_CORPORATES,
    fetchOwnerDashboardCorporatesSaga
  );

  yield takeLatest(sagaActions.SELECT_CORPORATE, selectCorporateSaga);

  yield takeLatest(
    sagaActions.FETCH_OWNER_DASHBOARD_CORPORATE_FACILITIES,
    fetchOwnerDashboardCorporateFacilitiesSaga
  );

  yield takeLatest(
    sagaActions.FETCH_OWNER_DASHBOARD_CORPORATE_FACILITY_DETAILS,
    fetchOwnerDashboardCorporateFacilityDetailsSaga
  );
}

export default rootSagas;
